import { IonButton, IonItem, IonLabel, IonList, IonModal, IonToggle } from '@ionic/react'
import React, { useEffect, useRef, useState } from 'react'
import { TitleForm } from '../../../../../../components/Atoms/TitleForm'
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks'
import { editNotificationsInApp } from '../../../../../../store/states/userPreference'

const ListToggleNotificationsInApp: React.FC = () => {
  const userPreference = useAppSelector(store => store.userPreference)
  const dispatch = useAppDispatch()
  const modal = useRef<HTMLIonModalElement>(null)
  const [checked, setCheked] = useState({
    sound: userPreference.notifications.inApp.sound,
    vibration: userPreference.notifications.inApp.vibration
  })

  useEffect(() => {
    setCheked({
      sound: userPreference.notifications.inApp.sound,
      vibration: userPreference.notifications.inApp.vibration
    })
  }, [userPreference])

  const onChange = (e: any) => {
    setCheked(prevValue => ({
      ...prevValue,
      [e.target.name]: e.detail.checked
    }))
  }

  function dismiss () {
    dispatch(editNotificationsInApp(checked))
    modal.current?.dismiss()
  }

  return (
		<IonModal ref={modal} trigger="open-modal-in-app" initialBreakpoint={0.75} breakpoints={[0, 0.25, 0.5, 0.75]}>
			<div className="ion-padding">
				<TitleForm title="In-App" customClass="ion-margin-start" />
				<IonList>
					<IonItem>
						<IonLabel>Sonido</IonLabel>
						<IonToggle color="secondary" name="sound" checked={checked.sound} slot="end" onIonChange={e => { onChange(e) }}></IonToggle>
					</IonItem>
					<IonItem>
						<IonLabel>Vibración</IonLabel>
						<IonToggle color="secondary" name="vibration" checked={checked.vibration} slot="end" onIonChange={e => { onChange(e) }}></IonToggle>
					</IonItem>
				</IonList>
				<div className="ion-text-end">
					<IonButton color="secondary" shape="round" type="submit" onClick={() => { dismiss() }}>Guardar</IonButton>
					<IonButton color="secondary" shape="round" fill="clear" type="button" onClick={async () => await modal.current?.dismiss()}>Cancelar</IonButton>
				</div>
			</div>
		</IonModal>
  )
}

export default ListToggleNotificationsInApp
